export default "__VITE_ASSET__BFnsxlxV__"